import { AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Carousel } from "primeng/carousel";
import { ImageGalleryModalComponent } from "src/app/shared/components/image-gallery-modal/image-gallery-modal.component";
import { ApiService, UtilsService } from "src/app/shared/services";
import { EnvService } from "src/app/shared/services/env.service";

@Component({
  selector: "app-booking-paypal",
  templateUrl: "./booking-paypal.component.html",
  styleUrls: ["./booking-paypal.component.less"],
})
export class BookingPaypalComponent implements OnInit, AfterViewInit {
  @Input() isHandset = false;

  logoPath = "";
  amount: number;
  roomId: string;
  bookForm: any;
  testimonialToShow: any;
  trustPilotStarsPath = "assets/image/trustpilot_stars.png";
  guarantee =
    "https://lazysuzy-images.s3.us-east-2.amazonaws.com/site/design/guarantee.png";

  initials: any;
  promo = '';
  promoErr: string = '';
  promoDetails: any;
  subtotal: number;
  testimonalList: any[] = [];
  discountAvailable: boolean;
  discountData: any;
  noOfRooms: any = 1;
  roomsArr: any[] = [];
  checkoutAmount: number = 0;
  expandedReview: number | null = null;

  constructor(
    private api: ApiService,
    private router: Router,
    public env: EnvService,
    private utils: UtilsService,
    private actRouter: ActivatedRoute,
    private matDialog: MatDialog,
  ) {
     Carousel.prototype.onTouchMove = () => { };
    this.api.onInitLoaded = false;
    this.api.onInitLoadedMob = false;
    this.api.quizCategory = null;
    // this.getDesignPayment();
  }

  get deviceHeight(): number {
    return window.innerHeight;
  }

  get deviceWidth(): number {
    return window.innerWidth;
  }


  toggleReview(index: number): void {
    this.expandedReview =
      this.expandedReview === index ? null : index;
  }

  getInitials(name: string): string {
    if (!name) {
      return '';
    }

    return name
      .split(' ')
      .map(word => word.charAt(0))
      .slice(0, 2)
      .join('')
      .toUpperCase();
  }

  isTextOverflow(text: string): boolean {
    return (text && text.length > 250) ? true : false; // adjust as needed
  }

  continue() {

  }

  getPromoErr(e) {
    this.promoDetails = null;
    if (e.error_msg) {
      this.promoErr = e.error_msg;
    } else if (e.length === 0) {
      this.promoDetails = null;
    } else {
      this.promoDetails = e;

      //   this.subtotal = (+this.amount)- (e.total_discount +this.noOfRooms) ; 
      //  this.amount = this.subtotal; //( (this.discountData && this.discountData.price_discount) ? this.getDiscountAmount :
      //   // this.discountData.design_book_amount)
      //   // - this.promoDetails.total_discount
      this.changeAmount();
    }
  }

  ngOnInit(): void {
    this.logoPath = this.env.logoPathWhite;
    this.get();
    this.getDiscountData();
    window.scrollTo(0, 0);
    this.hideIntercomIcon();
    this.utils.isHandset().subscribe((handset) => {
      this.isHandset = handset.matches;
      if (this.deviceWidth <= 900) {
        this.isHandset = true;
      }
    });

    // this.roomId = this.actRouter.snapshot.params.bookingId;

    this.api.getDesignTestimonials().subscribe((testimonials: any[]) => {
      const randomIdx = Math.round(Math.random() * 10) % testimonials.length;
      // this.testimonalList = testimonials;
      this.testimonalList = testimonials.map((item, index) => ({
        ...item,
        _index: index
      }));
      this.testimonialToShow = testimonials[randomIdx];
      setTimeout(() => {
        this.setEqualHeights()
      }, 500);

    });
  }


  get() {
    this.isLoading = true;

    const user = JSON.parse(localStorage.getItem("user"));
    this.api.getAllAppointments("", "", user?.id).subscribe((res) => {
      if (res && res.length > 0) {
        this.noOfRooms = res.filter(f => f.status == '01' && f.checkout == 1).length > 0 ? res.filter(f => f.status == '01' && f.checkout == 1).length : 1;
        this.roomsArr = res.filter(f => f.status == '01' && f.checkout == 1);
        // this.noOfRooms = res.length;
        // this.roomsArr = res;
        this.roomId = this.roomsArr.map(m => m.room_id).join(',');

        this.isLoading = false;
        this.changeAmount();
      }
    }, err => this.isLoading = false
    );
  }

  isLoading: boolean = false;

  removeArr(i) {

    this.isLoading = true;
    const data = { room_id: this.roomsArr[i].room_id, checkout: 0 };
    this.api.updateDesignCheckout(data).subscribe((res: any) => {
      this.roomsArr[i].checkout = 0;
      this.roomsArr.splice(i, 1);
      this.noOfRooms = this.roomsArr.length;
      this.isLoading = false;
      this.roomId = this.roomsArr.map(m => m.room_id).join(',');
      this.changeAmount();
      this.api.callPaymentStripe$.next(true);
    }, err => { this.isLoading = false });
  }

  changeAmount() {
    const pkg = +this.noOfRooms;
    const multiply = this.discountData?.price_discount ? this.getDiscountAmount : this.discountData?.design_book_amount;
    let discountVal = 0;
    if (this.promoDetails) {
      discountVal = this.promoDetails.total_discount * pkg
    }
    this.subtotal = (multiply * pkg) - discountVal;
    this.amount = (multiply * pkg) - discountVal;
    this.checkoutAmount = this.amount;
  }

  getRoomVal(room): string {
    return this.api.getRoomValue(room);
  }


  getDiscountData() {
    this.api.getDiscountData().subscribe((res: any) => {
      if (res) {
        if (res.price_discount) {
          this.discountAvailable = true;
        }
        this.discountData = res;
        this.changeAmount();


      }
    })
  }
  get getDiscountAmount() {
    let discount = ((+this.discountData.design_book_amount) * (1 - ((+this.discountData.price_discount) / 100)));
    return (+discount);
  }
  get isLoggedIn(): boolean {
    return (
      JSON.parse(localStorage.getItem("user")) &&
      JSON.parse(localStorage.getItem("user")).email.length > 0
    );
  }

  hideIntercomIcon() {
    const interval = setInterval(() => {
      const intercom = document.getElementsByClassName(
        "intercom-lightweight-app"
      )[0];
      const intercomApp = document.getElementsByClassName("intercom-app")[0];

      if (intercom) {
        intercom.classList.add("dn");
        clearInterval(interval);
      }
      if (intercomApp) {
        intercomApp.classList.add("dn");
        clearInterval(interval);
      }
    }, 1000);
  }
  getDesignPayment() {
    this.api.designPayment().subscribe((res: any) => {
      this.amount = res.amount / 100;
    });
  }

  get boxWidth(): number {
    return document.getElementById("summaryBox")?.clientWidth;
  }
  applyPromo() {
    if (this.promo) {
      this.promoErr = '';
      this.api.promoObserver$.next(this.promo);
      // this.subtotal = this.discountData.design_book_amount - this.promoDetails.total_discount

    }
  }
  removePromo() {
    this.promo = '';
    this.api.promoObserver$.next('--Remove--');
    setTimeout(() => {
      this.promoDetails = null;
      this.changeAmount();
    }, 500);
  }
  goToCompare() {
    this.router.navigate([]).then(() => {
      window.open(`/design/compare-havenly`);
    });
  }




  openGallery(img: string): void {
    this.matDialog.open(ImageGalleryModalComponent, {
      data: { gallery: [img] },
      panelClass: 'full-screen-dialog',
      maxWidth: '100vw',
      height: '0',
      autoFocus: false,
      restoreFocus: false
    });
  }

  execPayment(event) {
    if (event.status === "COMPLETED" || event.status === true) {
      this.router.navigate([`/design/rooms/landing`]);
    }


  }

  @ViewChildren('reviewCard') reviewCards!: QueryList<ElementRef>;

  ngAfterViewInit() {
    setTimeout(() => {
      // this.setEqualHeights();
      this.hideIntercomIcon();
    }, 2000);

  }

  setEqualHeights() {
    const heights = this.reviewCards.map(card => card.nativeElement.offsetHeight);
    const maxHeight = Math.max(...heights);
    this.reviewCards.forEach(card => {
      card.nativeElement.style.height = `${maxHeight}px`;
    });
  }

  getHeight(index:number):string{
    const d = document.getElementById('reviewContent'+index)?.offsetHeight;
    return d ? ((d+350)+'px') : 'auto';
  }

}